<template>
  <v-app id="inspire">
    <v-card-title>
      Physcial Target Definition Data
      <v-dialog width="unset" height="unset" v-model="dialogs.addNewTemplate">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ml-5" color="secondary" v-bind="attrs" v-on="on">Add new</v-btn>
        </template>
        <v-card class="pa-2" background="white" height="600" width="600">
          <v-textarea v-model="newTemplate" label="New physical target definition" clearable no-resize rows="17"> </v-textarea>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="dialogs.addNewTemplate = false">close</v-btn>
            <v-btn
              color="primary"
              @click="
                addNewPhysicalTarget(newTemplate);
                dialogs.addNewTemplate = false;
              "
              >Add definition</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="getPhysicalTargetDefinition"
      :expanded.sync="expanded"
      :hide-default-footer="true"
      disable-pagination
      show-expand
      single-expand
      item-key="guid"
      @click:row="refetchReleases()"
    >
    <template v-slot:item.released="{ item }">
          <v-icon v-if="item.released == 'RELEASED'">mdi-check</v-icon>
          <v-icon v-else>mdi-close</v-icon>
    </template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length">
          <v-card-actions>
            <v-btn @click="generateRelease(item.guid, 'RELEASE')" color="secondary"
              >Generate Release</v-btn
            >
          </v-card-actions>
          <v-text-field
            v-model="inputVersionFilter"
            label="Version Filter"
            name="inputVersionFilter"
            type="text"
            v-on:keyup.enter="submitVersionFilter"
          ></v-text-field>
          <v-data-table :headers="releaseHeaders" :items="getPhysicalTargetDefinitionReleaseByFilter">
            <!-- ACTIONS -->
            <template v-slot:item.actions="{ item }">
              <v-btn icon v-bind="attrs" v-on="on" @click="deletePhysicalTargetRelease(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <!-- DOWNLOAD BUTTON -->
              <v-btn icon v-bind="attrs" v-on="on" @click="downloadRelease(item.binaryFileUuid)">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>
        <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </v-app>
</template>

<script>
  import {
    ADD_OR_UPDATE_PHYSICAL_TARGET_DEFINITION_MUTATION,
    GET_PHYSICAL_TARGET_DEFINITION_QUERY,
    GENERATE_PHYSICAL_TARGET_DEFINITION_MUTATION,
    GET_PHSYSICAL_TARGET_DEFINITION_RELEASE_QUERY,
    DELETE_PHYSICAL_TARGET_DEFINITION_RELEASE_MUTATION
  } from '../../graphql/targetScoringDefinitionQueries.js';
  import { DownloadFileFromBinaryStorage } from '../../utils/UBinaryStorage';

  export default {
    components: {
      CConfirmationDialog: () => import('../common/CConfirmationDialog'),
    },
    created() {
      this.refetchPackages();
    },
    data() {
      return {
        newTemplate: '',
        id: '',
        search: '',
        tag: '',
        expanded: [],
        headers: [
          { text: 'Name', value: 'name', sortable: true },
          {
            text: 'ID',
            value: 'guid',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Version',
            value: 'version',
            sortable: true,
          },
          { text: 'Released', value: 'released', sortable: false},
        ],
        releaseHeaders: [
          { text: 'Version', value: 'version', sortable: true },
          { text: 'Date', value: 'dateTime', sortable: false },
          {
            text: '',
            value: 'actions',
            sortable: false,
            align: 'right',
            width: '10%',
          },
        ],
        getPhysicalTargetDefinition: [],
        getPhysicalTargetDefinitionReleaseByFilter: [],
        dialogs: {
          addNewTemplate: false,
        },
        uploading: false,
        inputVersionFilter: '',
        versionFilter: '',
      };
    },
    apollo: {
      $client: 'targetScoringDefinitionClient',
      getPhysicalTargetDefinition: {
        query: GET_PHYSICAL_TARGET_DEFINITION_QUERY,
        loadingKey: 'loading',
        options: { fetchPolicy: 'cache-and-network' },
      },

      getPhysicalTargetDefinitionReleaseByFilter:{
        query: GET_PHSYSICAL_TARGET_DEFINITION_RELEASE_QUERY,
          variables() {
          // Reactive parameters
          return {
            physicaltargetDefinitionId: this.expanded[0].guid, // Template ID
            versionFilter: this.versionFilter,
            limit: 5,
          };
        },
        skip() {
          return this.expanded.length === 0; // Skip query when not expanded
        },
        loadingKey: 'loading',
      },
    },

    methods: {
      async addNewPhysicalTarget(){
          try {
            // Set uploading state to indicate that the upload process is ongoing
            this.uploading = true;
            const PTD = JSON.parse(this.newTemplate);
            await this.$apollo.mutate({
              mutation: ADD_OR_UPDATE_PHYSICAL_TARGET_DEFINITION_MUTATION,
              variables: {
                id: PTD.guid,
                physicaltargetDefinition: PTD,
              },
              context: {
                hasUpload: true,
              },
            });

            this.uploading = false;
            this.newTemplate = '';
            this.dialogs.upload = false;

            this.refetchPackages();
          } catch (error) {
            console.error(error);
            this.uploading = false;
          }
        
      },
      refetchPackages() {
        
         this.$apollo.queries.getPhysicalTargetDefinition.refetch();
      },
      refetchReleases() {
        this.$apollo.queries.getPhysicalTargetDefinitionReleaseByFilter.refetch();
        this.versionFilter = '';
      },

      async generateRelease(id, increaseVersion) {
        console.log(`Generating release of ${id} with ${increaseVersion}`);
          await this.$apollo.mutate({
          mutation: GENERATE_PHYSICAL_TARGET_DEFINITION_MUTATION,
          variables: {
            id: id,
            increaseVersion: increaseVersion,
          },
        });

        this.refetchPackages();
        this.refetchReleases();
      },
      async downloadRelease(binaryFileId) {
        DownloadFileFromBinaryStorage(binaryFileId);
      },
      async deletePhysicalTargetRelease(id) {
        if (
          await this.$refs.confirmationDialog.open(
            'Are you sure you want to delete this shooting program template release?'
          )
        ) {
          try {
              await this.$apollo.mutate({
                  mutation: DELETE_PHYSICAL_TARGET_DEFINITION_RELEASE_MUTATION,
                  variables: {
                    id: id,
                  },
                    });
          } catch (err) {
            alert('Error deleting template! ' + err.message);
          }
          this.refetchReleases();
        }
      },

    },
  };
</script>
